import { createSlice } from '@reduxjs/toolkit';
import { getUserApi } from '../../../rtk-apis/users/getUser';
import { getPrefillUser } from '../../../rtk-apis/users/prefillUser';

const initialState = {
  status: '',
  result: '',
  msg: '',
  loading: false,
};

const getPrefillUserSlice = createSlice({
  name: 'getPrefillUser',
  initialState,
  reducers: {
    clearPrefillUserState: state => {
      state.status = '';
      state.result = '';
      state.msg = '';
      state.loading = false;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(getPrefillUser.pending, state => {
        state.loading = true;
        state.status = 'PENDING';
      })
      .addCase(getPrefillUser.fulfilled, (state, action) => {
        state.loading = false;
        state.status = 'SUCCESS';
        state.result = action?.payload;
        state.msg = action?.payload?.msg || 'User fetched successfully.';
      })
      .addCase(getPrefillUser.rejected, (state, action) => {
        state.loading = false;
        state.status = 'FAILED';
        state.result = (action?.payload as string) || 'Something went wrong';
      });
  },
});

export const { clearPrefillUserState } = getPrefillUserSlice.actions;
export default getPrefillUserSlice.reducer;
